// DS: i1.5
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const BirthdayCake: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <g>
        <path d="M8.162 1.052c.542.691 1.246 1.59.542 2.559-.379.484-.975.553-1.408 0-.704-.969 0-1.868.542-2.56a.28.28 0 0 1 .324 0ZM9 5H7v2H3.227C2.545 7 2 7.694 2 8.44v.41c.455.106.636.266.955.586.636.64 1.227.64 1.818 0 .772-.8 1.545-.8 2.318 0 .636.64 1.182.64 1.818 0 .773-.8 1.545-.8 2.318 0 .637.64 1.182.64 1.819 0 .318-.32.545-.48.954-.586v-.41C14 7.695 13.5 7 12.818 7H9V5Z" />
        <path d="M2.727 10.757c.773.915 1.546.915 2.318 0 .637-.732 1.182-.732 1.819 0 .772.915 1.545.915 2.318 0 .59-.732 1.182-.732 1.818 0 .773.915 1.5.915 2.273 0 .273-.305.409-.427.727-.549V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2.792c.34.114.442.228.676.492l.051.057Z" />
      </g>
    </svg>
  </IconWrap>
);
BirthdayCake.displayName = 'BirthdayCake';

export default BirthdayCake;
